import { stickyButtons } from './features/sticky-buttons';

stickyButtons('.js-sticky-cta', '.js-sticky-buttons');
